const HOURS = [
  { day: "Monday - Friday", time: "8:00 AM - 5:00 PM", open: true },
  { day: "Saturday", time: "Closed", open: false },
  { day: "Sunday", time: "Closed", open: false },
];

export const MapHours = () => (
  <section id="visit" data-testid="map-hours-section" className="py-24 md:py-32 bg-[#faf8f5] text-[#1f281e]">
    <div className="max-w-6xl mx-auto px-6">
      <div className="mb-12 reveal">
        <span className="font-mono-type text-xs uppercase tracking-[0.18em] text-[#2d4a22] font-semibold block mb-2">
          Find Us In Paramount
        </span>
        <h2 className="font-display text-3xl md:text-5xl uppercase text-[#1f281e]">Visit Or Call The Yard</h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-7 reveal reveal-d1">
          <div className="border border-[#2d4a22]/20 overflow-hidden bg-[#e4dacb] aspect-[4/3]">
            <iframe
              title="Sahagun Landscape — 15306 Castana Ave, Paramount CA 90723"
              data-testid="google-map"
              src="https://www.google.com/maps?q=15306+Castana+Ave,+Paramount,+CA+90723&output=embed"
              className="w-full h-full border-0"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>

        <div className="lg:col-span-5 reveal reveal-d2">
          <div className="bg-[#f2ece1] border border-[#2d4a22]/20 p-8 h-full flex flex-col justify-between">
            <div>
              <h3 className="font-display text-2xl uppercase mb-6" data-testid="hours-heading">Working Hours</h3>
              <ul className="divide-y divide-[#2d4a22]/10" data-testid="hours-list">
                {HOURS.map((h) => (
                  <li key={h.day} className="flex items-center justify-between py-3">
                    <span className="text-sm font-semibold uppercase tracking-wide">{h.day}</span>
                    <span className={`text-sm ${h.open ? "text-[#2d4a22] font-bold" : "text-[#8a8272]"}`}>
                      {h.time}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="pt-6 mt-6 border-t border-[#2d4a22]/15 space-y-3">
              <div>
                <span className="text-xs uppercase font-bold text-[#2d4a22] block mb-1">Address</span>
                <p className="text-sm" data-testid="visit-address">15306 Castana Ave, Paramount, CA 90723</p>
              </div>
              <div>
                <span className="text-xs uppercase font-bold text-[#2d4a22] block mb-1">Phone</span>
                <a href="tel:+13232204640" data-testid="visit-phone" className="text-sm font-semibold hover:text-[#2d4a22] transition-colors">
                  +1 (323) 220-4640
                </a>
              </div>
              <div>
                <span className="text-xs uppercase font-bold text-[#2d4a22] block mb-1">Follow Our Work</span>
                <a
                  href="https://www.instagram.com/sahagungroup"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="visit-instagram"
                  className="inline-flex items-center gap-2 text-sm font-semibold hover:text-[#2d4a22] transition-colors"
                >
                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                  </svg>
                  @sahagungroup
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
